import type { PluginExports } from 'graylog-web-plugin/plugin';

import { INTERNAL_DATA_LAKE_STORAGE_TYPE } from 'data-lake/preview/types/internal/Constants';
import SearchResultsFromJSON from 'data-lake/preview/types/internal/SearchResultsFromJSON';
import InternalDataLakePreview from 'data-lake/preview/types/internal/InternalDataLakePreview';
import InternalDataLakeIcon from 'data-lake/preview/types/internal/InternalDataLakeIcon';
import { INTERNAL_DATA_LAKE_QUERY_TYPE, INTERNAL_DATA_LAKE_SEARCH_TYPE } from 'data-lake/preview/Constants';

const internalDataLakeExport: PluginExports = {
  searchTypes: [
    {
      type: INTERNAL_DATA_LAKE_SEARCH_TYPE,
      handler: SearchResultsFromJSON,
      defaults: {},
    },
  ],
  dataLakeStorageTypes: [
    {
      icon: InternalDataLakeIcon,
      previewComponent: InternalDataLakePreview,
      searchType: INTERNAL_DATA_LAKE_SEARCH_TYPE,
      queryType: INTERNAL_DATA_LAKE_QUERY_TYPE,
      storageType: INTERNAL_DATA_LAKE_STORAGE_TYPE,
    },
  ],
};

export default internalDataLakeExport;
